import { useMemo } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

export const useFeatureFlag = feature => {
  const { allContentfulFeatureFlag } = useStaticQuery(featureFlagQuery);

  const featureFlags = useMemo(() => {
    const contentfulFlags = allContentfulFeatureFlag.edges
      .map(({ node }) => node)
      .reduce(
        (acc, { name, publicSiteToggle }) => ({
          ...acc,
          [formatFeatureKey(name)]: publicSiteToggle,
        }),
        {},
      );
    return contentfulFlags;
  }, [allContentfulFeatureFlag.edges]);

  return !!featureFlags[formatFeatureKey(feature)];
};

const formatFeatureKey = feature => feature.toUpperCase().trim();

const featureFlagQuery = graphql`
  query {
    allContentfulFeatureFlag(
      filter: { channel: { eq: "PSITE" }, node_locale: { eq: "en-CA" } }
    ) {
      edges {
        node {
          name
          publicSiteToggle
        }
      }
    }
  }
`;
